import Stack from "@mui/material/Stack";
import { type FC, type PropsWithChildren } from "react";


export const ModalFooter: FC<PropsWithChildren> = ({ children }) => {
	return (
		<Stack
			sx={{
				zIndex: 1300,
				bottom: 0,
				width: "100%",
				p: 4,
				boxShadow: "extraFar",
				backgroundColor: "white.main",
			}}
		>
			{children}
		</Stack>
	);
};

